import BlibliCheckoutProjectImage from "../../../assets/images/projects/blibli-checkout-projects/thumbnail.png";
import { ProjectDataProps } from "../props";

export default {
  title: "Blibli Checkout & Promo Projects",
  description: "A series of product features on Checkout & Promo Blibli",
  image: BlibliCheckoutProjectImage,
  path: "/blibli-checkout-projects",
} as ProjectDataProps;
